import { render, staticRenderFns } from "./order-summary-mini.vue?vue&type=template&id=c25a86ee"
import script from "./order-summary-mini.vue?vue&type=script&lang=ts"
export * from "./order-summary-mini.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c25a86ee')) {
      api.createRecord('c25a86ee', component.options)
    } else {
      api.reload('c25a86ee', component.options)
    }
    module.hot.accept("./order-summary-mini.vue?vue&type=template&id=c25a86ee", function () {
      api.rerender('c25a86ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "orders/order-summary-mini.vue"
export default component.exports